import { Share2 } from "lucide-react";

export const WhatsAppShareButton = ({ kind, item }) => {
  const shareUrl = `${process.env.REACT_APP_BACKEND_URL}/api/share/${kind}/${item.id}`;
  const label = kind === "job" ? "Guarda questo annuncio di lavoro" : "Guarda questo servizio";
  const text = `${label} su LavoroTicino.ch: ${item.title}\n${shareUrl}`;

  return (
    <a
      href={`https://wa.me/?text=${encodeURIComponent(text)}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`whatsapp-share-${kind}-btn`}
      className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#25D366] text-white text-sm font-medium hover:bg-[#1ebe5a] transition-colors"
    >
      <Share2 className="w-4 h-4" />
      Condividi su WhatsApp
    </a>
  );
};
